<template>
 <h1>Forms</h1>
</template>

<script>

export default {
	name: 'forms'
}

</script>
